import React, { Component } from 'react'
import styled from 'styled-components'

import styles from './styles.module.sass'
import { Container, Row, Col } from 'react-bootstrap'

import closeIcon from './closeIcon.svg'

import Axios from 'axios'
import URL from '../../config/url'
import Form from '../../components/Form'

class Portfolio extends Component {
  state = {
    photos: [],
    // isOpen: true,
  }

  componentDidMount = () => {
    this.getData()
    this.getPortfolio()
    // this.getType()
    this.fetchType('type')
    this.fetchStyle('style')
  }

  getType = () => {
    console.log(window.location.pathname)
    switch (window.location.pathname) {
      case '/portfolio/restaurants':
        return { title: 'Рестораны', type: 1 }
      case '/portfolio/offices':
        return { title: 'Офисы', type: 2 }
      case '/portfolio/hotels':
        return { title: 'Отели', type: 3 }
      default:
        return {}
    }
  }

  fetchType = async type => {
    const { status, data } = await Axios({
      url: URL + `api/admin/place-${type}`,
      method: 'get',
    })
    if (status === 200) {
      const sortedArr = data.sort((a, b) => a.position - b.position)
      this.setState({
        ...this.state,
        activeType: sortedArr[0].id,
        dataList: {
          ...this.state.dataList,
          [type]: sortedArr,
        },
      })
    }
  }
  fetchStyle = async type => {
    const { status, data } = await Axios({
      url: URL + `api/admin/place-${type}`,
      method: 'get',
    })
    if (status === 200) {
      const sortedArr = data.sort((a, b) => a.position - b.position)
      this.setState({
        dataList: {
          ...this.state.dataList,
          [type]: sortedArr,
        },
      })
    }
  }

  getData = async () => {
    const { status, data = [] } = await Axios({
      method: 'get',
      url: URL + 'api/admin/place',
    })
    if (status === 200) {
      this.setState({ data })
    }
  }

  getPortfolio = (id, expanded) => {
    if (expanded) {
      this.setState({ photos: [] })
    } else {
      Axios({
        method: 'get',
        url: URL + `api/admin/place-portfolio?place_id=${this.getType().type}`,
      }).then(({ data }) => {
        this.setState({ photos: data })
      })
    }
  }
  onChangeFilter = id => () => this.setState({ activeType: id })

  render() {
    const { photos = [], activeType = {}, dataList = {}, isOpen } = this.state
    const { type = [], style = [] } = dataList

    console.log('state', this.state)
    return (
      <>
        <Container>
          <Row>
            <Col>
              <div className={styles.title}>{this.getType().title}</div>
            </Col>
          </Row>
          <Row>
            <Col>
              <ul className={styles.list}>
                {type.map(({ id, title }) => (
                  <Li
                    key={id}
                    onClick={() => this.setState({ activeType: id })}
                    type={type}
                    isActive={+id === +activeType}
                    label={title}
                  />
                ))}
              </ul>
            </Col>
          </Row>
          {style.map(el => {
            const filterArr = [...photos]
              .filter(photo => +photo.type === +activeType)
              .filter(photo => +photo.style === +el.id)

            if (filterArr.length > 0) {
              return (
                <div key={el.id} className={styles.style}>
                  <div className={styles.style__title}>{el.title}</div>
                  <Row>
                    {filterArr.map(photo => (
                      <Col key={photo.id} xs={12} md={6} lg={4}>
                        <div
                          onClick={() => this.setState({ isOpen: true })}
                          style={{ backgroundImage: `url(${URL + photo.img})` }}
                          className={styles.style__img}></div>
                      </Col>
                    ))}
                  </Row>
                </div>
              )
            }
            return null
          })}
        </Container>

        <Modal isOpen={isOpen}>
          <div className="modal-overlay"></div>
          <div className="body-form">
            <Close onClick={() => this.setState({ isOpen: false })}>
              <Maximize
                src={closeIcon}
                onClick={() => this.setState({ isOpen: false })}
              />
            </Close>
            <Form
              title="Запросите каталог"
              btnText="Связаться с нами!"
              subject="Портфолио"
              callBack={() => this.setState({ isOpen: false })}
            />
          </div>
        </Modal>
      </>
    )
  }
}

export default Portfolio

const Li = ({ isActive, type, label, onClick }) => {
  return (
    <li
      onClick={onClick}
      className={isActive ? styles.list__item__active : styles.list__item}>
      • {label}
    </li>
  )
}

const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${props => (props.isOpen ? 9999 : -1)};
  display: flex;
  justify-content: center;
  align-items: center;
  & .modal-overlay {
    position: absolute;
    backdrop-filter: blur(5px);
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100vh;
  }
  & .body {
    width: 80%;
    max-width: 800px;
    min-width: 200px;
    max-height: 600px;
    border-radius: 8px;
    position: absolute;
  }
  & .body-form {
    min-width: 260px;
    border-radius: 8px;
    position: absolute;
  }
`
const Maximize = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 5%;
  bottom: 5%;
`
const Close = styled.div`
  color: #fff;
  z-index: 9999;
  font-size: 30px;
  position: absolute;
  width: 25px;
  height: 25px;
  right: -25px;
  cursor: pointer;
  top: -25px;
`
